<configurator-header></configurator-header>

<ion-content scrollY="false" class="insurance-plan-wrapper">
  <div class="one3d-emi-wrapper">
    <div class="one3d-content-header one3d-custom-border-bottom ">
      <h1 class="one3d-content-header-title" translate>INSURANCE_PLAN.INSURANCE_PLAN</h1>
      <button (click)="closeInsurance()">
        <span
          ><img
            src="assets/img/icons/one3d-close-icon.svg"
            alt="close page icon"
        /></span>
      </button>
    </div>
  </div>
  <div class="one3d-scrollable-wrapper-custom"> 
      <div 
        class="one3d-summary-ext-int-wrapper   new-pt-10 new-pb-0"
      >
        <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0 new-pb-0">
          <ion-row>
            <ion-col size="6">
              <span class="one3d-summary-item-name">
                <strong translate> INSURANCE_PLAN.MODEL </strong>
              </span>
            </ion-col>
            <ion-col size="6">
              <div class="one3d-summary-content-right-col">
                <span class="one3d-summary-item-value">
                  {{modelName}}
                </span>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>

      <div 
        class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin new-pt-4 new-pt-10  pb-10"
      >
        <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
          <ion-row>
            <ion-col size="6">
              <span class="one3d-summary-item-name">
                <strong translate>  INSURANCE_PLAN.VARIANT </strong>
              </span> 
            </ion-col>
            <ion-col size="6">
              <div class="one3d-summary-content-right-col">
                <span class="one3d-summary-item-value">
                  {{variantDetails}}
                </span>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
      <!--  -->
      <!--<form [formGroup]="insuranceForm">
        <div class="one3d-summary-ext-int-wrapper one3d-summary-row-margin one3d-custom-border-bottom new-pt-10 pb-10">
          <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
              <div class="one3d-insurance-select-box-wrapper">
                <label class="one3d-insurance-select-box-label">STATE</label>
                <div class="one3d-insurance-select-box">
                  <select class="one3d-insurance-select" (change)="onStateSelection($event)" formControlName="state" >
                    <option hidden value="" disabled selected>Select state</option>
                    <option *ngFor="let item of stateList" [value]="item.state_id" >{{item.state_name}}</option>
                  </select>
                  <span class="one3d-bottom-arrow-angle"><img src="assets/img/icons/one3d-bottom-arrow-angle.svg" alt="close page icon" /></span>
                </div>
              </div>
              <div class="one3d-insurance-select-box-wrapper">
                <label class="one3d-insurance-select-box-label">CITY</label>
                <div class="one3d-insurance-select-box">
                  <select class="one3d-insurance-select" (change)="onCitySelection($event)" formControlName="city">
                    <option hidden value="" disabled selected>Select City</option>
                    <option *ngFor="let item of cityList" [value]="item.city_id" >{{item.city_name}}</option>
                  </select>
                  <span class="one3d-bottom-arrow-angle"><img src="assets/img/icons/one3d-bottom-arrow-angle.svg" alt="close page icon" /></span>
                </div>
              </div>
          </div>
        </div>

        <div 
          *ngIf="insuranceProvider"
          class="one3d-summary-ext-int-wrapper new-pt-10 new-pb-0"
        >
          <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0 new-pb-0">
            <ion-row>
              <ion-col size="6">
                <span class="one3d-summary-item-name">
                  <strong> INSURANCE PROVIDER </strong>
                </span>
              </ion-col>
              <ion-col size="6">
                <div class="one3d-summary-content-right-col">
                  <span class="one3d-summary-item-value">
                    {{insuranceProvider}}
                  </span>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>

        <div 
          *ngIf="premiumAmount"
          class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin new-pt-4 new-pt-10  pb-10"
        >
          <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
            <ion-row>
              <ion-col size="6">
                <span class="one3d-summary-item-name">
                  <strong> PREMIUM AMOUNT </strong>
                </span>
              </ion-col>
              <ion-col size="6">
                <div class="one3d-summary-content-right-col">
                  <span class="one3d-summary-item-value">
                      <strong > {{ globalService.currencyFormatter(premiumAmount) }}</strong>
                  </span>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>  

        <div class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin  new-pt-10 pb-10" *ngIf="uniquePlans.length>0" >
          <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
            <ion-row>
              <ion-col size="12">
                <span class="one3d-summary-item-name">
                  <strong > SELECT PLAN </strong>
                </span>
                <div class="one3d-kilometers-driven-wrap">
                  <ion-list> 
                    <ion-item
                      lines="none" 
                      class="extended-warranty-radio"
                      *ngFor="let itemPlan of uniquePlans , let i=index"
                      (click)="onPackageSelection(itemPlan)"
                    >
                      <input
                        type="radio"
                        formControlName="packageId"
                        [id]="itemPlan.PACKAGEID"
                        [value]="itemPlan.PACKAGEID"
                      />
                      <ion-label>  {{itemPlan.PACKAGENAME}}  </ion-label>
                    </ion-item>
                    <ion-item
                      lines="none" 
                      class="extended-warranty-radio"
                      (click)="onPackageSelection(zeroDep)"
                    >
                      <input
                        type="radio"
                        formControlName="packageId"
                        [id]="zeroDep.PACKAGEID"
                        [value]="zeroDep.PACKAGEID"
                      />
                      <ion-label>  Zero Dep (Standalone)  </ion-label>
                    </ion-item>
                  </ion-list>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>

        <div 
          class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin  new-pt-10 pb-10" 
          *ngIf="insuranceForm.value.packageId === 0 && chooseAddonsPlans.length > 0"
        >
          <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
            <ion-row>
              <ion-col size="12">
                <span class="one3d-summary-item-name">
                  <strong > Choose add ons </strong>
                </span>
                <div class="one3d-kilometers-driven-wrap one3d-choose-add-ons-options" *ngFor="let itemPlan of chooseAddonsPlans , let i=index">
                  <ion-list> 
                    <ion-item
                      lines="none" 
                      class="extended-warranty-radio"
                    >
                      <label class="new-label-checkbox-container"> {{itemPlan.ADDONDescription}} 
                        <input 
                          type="checkbox"
                          [id]="itemPlan.PACKAGEID"
                          [value]="itemPlan.PACKAGEID"
                          (change)="onCheckChange($event)"
                          (click)="onSelectingZeroAddons(itemPlan)" 
                        >
                        <span class="checkmark"></span>
                      </label>
                    </ion-item>
                  </ion-list>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </form> -->
      <!--  -->
      <div *ngIf="packageAddons.length>0"
        class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin new-pt-4 new-pt-10  pb-10"
      >
        <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0 new-pb-0"> 
          <div class="one3d-summary-item-name">
            <strong translate> INSURANCE_PLAN.PACKAGE_INCLUDES</strong>
          </div>
          <div class="one3d-package-data">
            <ul class="one3d-package-data-list">
              <li *ngFor="let item of packageAddons">
                {{item.addon_name}}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngIf="insuranceCost"
        class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin new-pt-4 new-pt-10  pb-10"
      >
        <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
          <ion-row>
            <ion-col size="6">
              <span class="one3d-summary-item-name">
                <strong translate> INSURANCE_PLAN.INSURANCE_COST </strong>
              </span>
            </ion-col>
            <ion-col size="6">
              <div class="one3d-summary-content-right-col">
                <span class="one3d-summary-item-value">
                    <strong> {{ globalService.currencyFormatter(insuranceCost) }}</strong>
                </span>
              </div>
            </ion-col>
            <!-- <ion-col size="12">
              <p class="premium-amount-add-ons-amount">
                <ion-text>
                  Premium amount + Add ons amount
                </ion-text>
              </p>
            </ion-col> -->
          </ion-row>
        </div>
      </div> 
  </div>  
  <div class="one3d-discalaimer-section-static">
    <div class="one3d-disclamier-btn-wrapper-static">
      <h4>
        <ion-text translate>INSURANCE_PLAN.DISCLAIMER</ion-text>
      </h4>
      <p>
        <ion-text translate>
          INSURANCE_PLAN.DISCLAIMER_NOTE
        </ion-text>
      </p>
    </div> 
  </div>

  <!-- Footer Buttons -->
  <div class="one3d-lhs-config-bottom-wrapper one3d-placeAtBottom-summary">
    <ion-row class="one3d-lhs-config-btn-row">
      <ion-col class="ion-no-padding" size="6">
        <ion-button
        (click)="skipWarranty()"
          class="one3d-lhs-config-btn one3d-lhs-config-left-btn"
          expand="full"
          fill="solid"

          translate
        >
        INSURANCE_PLAN.SKIP
        </ion-button>
      </ion-col>
      <ion-col class="ion-no-padding" size="6">
        <ion-button
          (click)="addToSummary()"
          [disabled]="insuranceCost == 0"
          class="one3d-lhs-config-btn one3d-lhs-config-right-btn"
          expand="full"
          translate
        >
        INSURANCE_PLAN.ADD_TO_SUMMARY
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-content>